import styled from 'styled-components';

export const Container = styled.header`
  background-color: ${({ theme }) => theme.colors.background.white};
  width: 100%;
  min-width: 0;
  min-height: 40px;
  border-bottom: 1px solid #cccbcc;

  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px 16px;

  padding: 5px 23px;

  span {
    white-space: nowrap;
  }

  .welcomeContainer {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 64px;
    flex: 1 1 auto;
    min-width: 0;

    div {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 16px;
    }
  }

  @media (max-width: 700px) {
    padding: 8px 12px;
    align-items: flex-start;

    .welcomeContainer {
      width: 100%;
      gap: 8px 16px;

      span {
        white-space: normal;
        overflow-wrap: anywhere;
      }

      > div {
        width: 100%;
      }
    }
  }

  @media (max-width: 600px) {
    position: relative;
    padding: 8px;
    gap: 8px;

    .welcomeContainer {
      gap: 6px;

      > span {
        max-width: calc(100% - 96px);
      }

      > div {
        align-items: flex-start;
        flex-direction: column;
        gap: 4px;
      }
    }
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  min-width: 0;
  align-items: center;
  gap: 16px;

  @media (max-width: 700px) {
    width: 100%;
    min-width: 0;
    gap: 8px 16px;
  }

  @media (max-width: 600px) {
    position: absolute;
    top: 8px;
    right: 8px;
    width: auto;
    justify-content: flex-end;
    gap: 12px;
  }
`;

export const Button = styled.button`
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.colors.orange.primary};
  transition: 0.2s filter;

  .mobileIcon {
    display: none;
  }

  &:hover {
    filter: brightness(0.8);
  }

  @media (max-width: 600px) {
    display: flex;
    width: 40px;
    height: 40px;
    align-items: center;
    justify-content: center;
    font-size: 22px;

    .buttonLabel {
      display: none;
    }

    .mobileIcon {
      display: block;
    }
  }
`;

export const SelectContainer = styled.div`
  min-width: 180px;
  max-width: 100%;

  border: 1px solid #cccbcc;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.white};

  transition: border-color 0.2s, box-shadow 0.2s;

  &:focus-within {
    border-color: ${({ theme }) => theme.colors.orange.primary};
    box-shadow: 0 0 0 3px rgba(245, 128, 37, 0.15);
  }

  @media (max-width: 600px) {
    width: 100%;
    min-width: 0;
  }
`;
